// Browser detection utilities. Browser classes are only used for narrowly
// scoped compatibility fixes; the visual design stays shared by all engines.

export const isSafari = () => {
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent;
  const vendor = navigator.vendor || '';
  const hasSafariToken = /Safari/i.test(ua);
  const isAppleWebKitBrowser = /Apple Computer/i.test(vendor);
  const isAnotherBrowser = /(Chrome|Chromium|CriOS|FxiOS|EdgiOS|OPiOS|Android)/i.test(ua);

  return hasSafariToken && isAppleWebKitBrowser && !isAnotherBrowser;
};

export const isChrome = () => {
  if (typeof navigator === 'undefined') return false;
  return /(Chrome|CriOS)/i.test(navigator.userAgent)
    && !/(Edg|EdgiOS|OPR|Opera)/i.test(navigator.userAgent);
};

export const isReducedMotionPreferred = () => {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};

export const applyBrowserOptimizations = () => {
  if (typeof document === 'undefined') return;

  if (isSafari()) {
    document.documentElement.classList.add('is-safari');
    document.body.classList.add('safari-browser');
  } else if (isChrome()) {
    document.documentElement.classList.add('is-chrome');
    document.body.classList.add('chrome-browser');
  }

  if (isReducedMotionPreferred()) {
    document.documentElement.classList.add('reduced-motion');
    document.body.classList.add('reduced-motion');
  }
};

export default {
  isSafari,
  isChrome,
  isReducedMotionPreferred,
  applyBrowserOptimizations
};
